<template>
  <div id="app">
    <MyComponent /> <!-- Use your component here -->
  </div>
</template>

<script>
// Import the component you want to display
import MyComponent from './components/ModelCoordinator.vue'

export default {
  name: 'ModelCoordinator',
  components: {
    MyComponent // Register your component here
  }
}
</script>
